<app-upload-document-button
  [allowedTypes]="acceptedImageMimeTypes"
  [multiple]="false"
  tooltip="Téléverser le contrat signé"
  (uploaded)="onDocumentUploaded($event[0].id)"
>
  <fa-icon class="signature" [icon]="faSignature"></fa-icon>
</app-upload-document-button>
